import { createStyles } from 'antd-style';

const useStyles = createStyles(() => {
  return {
    selectedArrow: {
      position: 'absolute',
      top: '35%',
      right: '16px',
    },
    ccSiderMenuItem: {
      '& .ant-menu-title-content': {
        paddingRight: 10,
      },
    },
  };
});

export default useStyles;
